var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreayDrag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 577"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 172",
    cx: 5.75,
    cy: 1.30435,
    rx: 1.25,
    ry: 1.30435,
    fill: "#9D9690"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 173",
    cx: 5.75,
    cy: 5.99966,
    rx: 1.25,
    ry: 1.30435,
    fill: "#9D9690"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 174",
    cx: 5.75,
    cy: 10.695,
    rx: 1.25,
    ry: 1.30435,
    fill: "#9D9690"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 190",
    cx: 1.25,
    cy: 1.30435,
    rx: 1.25,
    ry: 1.30435,
    fill: "#9D9690"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 192",
    cx: 1.25,
    cy: 5.99966,
    rx: 1.25,
    ry: 1.30435,
    fill: "#9D9690"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 194",
    cx: 1.25,
    cy: 10.695,
    rx: 1.25,
    ry: 1.30435,
    fill: "#9D9690"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreayDrag);
export default __webpack_public_path__ + "static/media/greay_drag.9d279510f64f731ab9568f9340392802.svg";
export { ForwardRef as ReactComponent };